import React, { Component, Fragment } from 'react';
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import axios from 'axios';
import AppURL from '../../api/AppURL';
import { Navigate } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class Jobs extends Component {

    constructor() {
        super();

        this.state = {
            name: '',
            email: '',
            address: '',
            contact: '',
            image: null,
            cv: null,
        };
    }

    componentDidMount() {
        window.scroll(0, 0);
    }

    nameOnChange = (e) => {
        this.setState({ name: e.target.value });
    }

    emailOnChange = (e) => {
        this.setState({ email: e.target.value });
    }

    addressOnChange = (e) => {
        this.setState({ address: e.target.value });
    }

    imageOnChange = (e) => {
        this.setState({
            image: e.target.files[0]
        });
    }
    contactOnChange = (e) => {
    this.setState({ contact: e.target.value });
}

    cvOnChange = (e) => {
        this.setState({
            cv: e.target.files[0]
        });
    }

    onFormSubmit = (event) => {

        event.preventDefault();

        const { name, email, address, image, cv } = this.state;

        if (!name) {
            toast.error("Enter your name");
            return;
        }

        if (!email) {
            toast.error("Enter your email");
            return;
        }

        if (!address) {
            toast.error("Enter your address");
            return;
        }

        if (!cv) {
            toast.error("Upload your CV");
            return;
        }

        let sendBtn = document.getElementById('sendBtn');
        sendBtn.innerHTML = "Submitting...";

        let formData = new FormData();

        formData.append('name', name);
        formData.append('email', email);
        formData.append('address', address);
        formData.append('contact', this.state.contact);

        if (image) {
            formData.append('image', image);
        }

        formData.append('cv', cv);

        axios.post(AppURL.Postjob, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        .then((response) => {

            if (response.status === 200) {

                toast.success("Application submitted successfully");

                this.setState({
                    name: '',
                    email: '',
                    address: '',
                    contact: '',
                    image: null,
                    cv: null
                });

                document.getElementById("requestForm").reset();
            }

            sendBtn.innerHTML = "Apply Now";
        })

        .catch((error) => {

    console.log(error.response);

    if(error.response){
        console.log(error.response.data);
        toast.error(error.response.data.message || "Server Error");
    }else{
        toast.error("Network Error");
    }

});
    }

    render() {


       



        if (!localStorage.getItem("token")) {
    return <Navigate to="/login" />;
}

        return (

            <Fragment>

                <div className="bg-light py-5">

                    <Container>

                        <h2 className="text-center mb-4">
                            <strong>Apply For Job</strong>
                        </h2>

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <Card.Body>

                            <Form id="requestForm" onSubmit={this.onFormSubmit}
                            >
                            <Row>
                                <Col md={6}>
                                    <input  type="text"  className="form-control mb-3" placeholder="Full Name"
                                        onChange={this.nameOnChange}
                                    />
                                </Col>
                    <Col md={6}>
                        <input type="email"  className="form-control mb-3"   placeholder="Email Address"
                            onChange={this.emailOnChange}
                        />

                            </Col>
                            <Col md={6}>
                            <input type="contact" className="form-control mb-3" placeholder="your contact "
                                onChange={this.contactOnChange}
                            />
                        </Col>




<Col md={6}>
    <input
        type="text"
        className="form-control mb-3"
        placeholder="Address"
        onChange={this.addressOnChange}
    />
</Col>

</Row>

<label>Upload Photo (Optional)</label>

<input
    type="file"
    accept="image/*"
    className="form-control mb-3"
    onChange={this.imageOnChange}
/>

<label>Upload CV (PDF/DOC/DOCX)</label>

<input
    type="file"
    accept=".pdf,.doc,.docx"
    className="form-control mb-3"
    onChange={this.cvOnChange}
/>

<Button
    id="sendBtn"
    type="submit"
    className="btn btn-primary w-100"
>
    Apply Now
</Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    </Container>
</div>
<ToastContainer />
</Fragment>
        );
    }
}

export default Jobs;